import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";
import {favoriteThreadSuccess} from "store/reducer/threads/favorite/reducer";

export const initialState = {
    status: ReducerStatuses.IDLE,
    error: "",
    filters: {
        search: "",
        categories: [],
        type: "all",
        order_by: "created_at|desc"
    },
    data: {
        threads: {},
    },
    current_page: 1,
    metadata: {
        pages: 0,
        hasNext: 0
    }
}

const slice = createSlice({
    name: "threads",
    initialState,
    reducers: {
        startThreadsSearch: (state) => {
            state.status = ReducerStatuses.LOADING;
            state.error = "";
        },
        successThreadsSearch: (state, {payload}) => {
            state.status = ReducerStatuses.SUCCESS;
            if(state.current_page === 1) {
                state.data = payload.data;
            } else {
                state.data.threads = {
                    ...state.data.threads,
                    ...payload.data.threads
                }
            }
            state.metadata = payload.metadata;
        },
        errorThreadsSearch: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        setThreadsSearchFilters: (state, {payload}) => {
            state.status = ReducerStatuses.IDLE;
            state.filters = {
                ...state.filters,
                ...payload
            };
            state.current_page = 1;
            state.error = ""
        },
        threadsSearchFetchNextPage: (state) => {
            state.current_page = state.current_page + 1;
            state.status = ReducerStatuses.LOADING;
        }
    },
    extraReducers: {
        [favoriteThreadSuccess]: (state, {payload}) => {
            const {id, favorite} = payload;
            if(state.data.threads[id]) state.data.threads[id].favorite = favorite;
        }
    }
});

const {reducer, actions} = slice;
export const {
    errorThreadsSearch, threadsSearchFetchNextPage, setThreadsSearchFilters, startThreadsSearch, successThreadsSearch
} = actions;
export default reducer;